import React from 'react';
import { useContext } from 'react';
import { Box } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';

export default function ProfileEditContainer({
  children,
}: {
  children: React.ReactNode;
}) {
  const {
    spacings: {
      profilePage: { profileEdit },
    },
  } = useContext(UiContext);

  const { isLessTablet, isLessLaptop } = useBooleanScreens();

  const sx = isLessTablet
    ? {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }
    : ({
        display: 'flex',
        alignItems: 'start',
        justifyContent: isLessLaptop ? 'space-between' : 'start',
        gap: profileEdit.avatarFormGap,
      } as any);

  return <Box sx={sx}>{children}</Box>;
}
